import config from "./config";

export function getBaseApi() {
    return config.api;
}
